module.exports = __webpack_public_path__ + "img/TKN.122b9f3a.svg";